import api, { unwrap } from './client';

export async function login(email, password) {
  const res = await api.post('/auth/login', { email, password });
  return unwrap(res);
}

export async function register(payload) {
  const res = await api.post('/auth/register', payload);
  return unwrap(res);
}

export async function me() {
  const res = await api.get('/auth/me');
  return unwrap(res);
}

export async function forgotPassword(email) {
  return unwrap(await api.post('/auth/forgot-password', { email }));
}

export async function resetPassword(token, password) {
  return unwrap(await api.post('/auth/reset-password', { token, password }));
}

export async function changePassword(currentPassword, newPassword) {
  return unwrap(await api.post('/auth/change-password', { currentPassword, newPassword }));
}

export async function sendOtp(phone, opts = {}) {
  const body = { phone };
  if (opts.purpose) body.purpose = opts.purpose;
  return unwrap(await api.post('/auth/send-otp', body));
}

export async function verifyOtp(phone, otp, opts = {}) {
  const body = { phone, otp };
  if (opts.referralCode) body.referralCode = opts.referralCode;
  return unwrap(await api.post('/auth/verify-otp', body));
}

// USER phone + OTP + password signup.
export async function signUpUser({ phone, otp, password, name, referralCode }) {
  const body = { phone, otp, password };
  if (name)         body.name         = name;
  if (referralCode) body.referralCode = referralCode;
  return unwrap(await api.post('/auth/sign-up', body));
}

// USER phone + password login (no OTP).
export async function signInUser(phone, password) {
  return unwrap(await api.post('/auth/sign-in', { phone, password }));
}

// USER forgot-password → sends OTP (purpose='reset').
export async function forgotPasswordOtp(phone) {
  return unwrap(await api.post('/auth/forgot-password-otp', { phone }));
}

// USER reset-password via OTP.
export async function resetPasswordOtp(phone, otp, password) {
  return unwrap(await api.post('/auth/reset-password-otp', { phone, otp, password }));
}

export async function loginSuperAdmin(email, password, code) {
  return unwrap(await api.post('/auth/login/super-admin', { email, password, code }));
}

export async function loginPortal(email, password) {
  return unwrap(await api.post('/auth/login/portal', { email, password }));
}

// MFA step 2 — send the SMS OTP + user id received in step-1 response
// to complete the login. Returns { user, token } like a normal login.
export async function verifyLoginOtp(userId, otp) {
  return unwrap(await api.post('/auth/verify-login-otp', { userId, otp }));
}

export async function clinicRegister(payload) {
  return unwrap(await api.post('/auth/clinic-register', payload));
}
